import * as React from 'react';
import { State } from 'xstate';
import { AutomataContext, AutomataEvent } from '../../../../../../Machines/organisations/search';
import { useSelector } from 'react-redux';
import { List } from 'immutable';
import { State as StoreState } from '../../../../../../Data/@records';
import { OrganisationRecord } from '../../../../../../Data/organisations/@records/Organisation';
import Organisation from './Organisation';

type Props = {
  current: State<AutomataContext, AutomataEvent>;
};
export default ({ current }: Props) => {
  const organisations = useSelector<StoreState, List<OrganisationRecord>>((state) =>
    state.organisations.organisations.filter((o) => o.name.toLowerCase().includes(current.context.term.toLowerCase())).toList(),
  );

  return (
    <div className="mb-2">
      {organisations.map((o) => (
        <Organisation key={o.identifier} organisation={o} />
      ))}
    </div>
  );
};
